import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { TranslateService } from '@ngx-translate/core';
import { GTMService } from '@services';
import { InstallationFeaturesStore, RichDevice } from '@store';
import {
  Feature,
  FeatureActionFields,
  FeatureCommands,
  FeatureNames,
  FeaturePropertyKey,
  ServiceTimeBasedCommands,
  ServiceTimeBasedProperties,
} from '@vi-iot/client/index';
import { Observable, tap } from 'rxjs';
import { SharedDependenciesModule } from 'src/app/shared';
import { CommonStandaloneModule } from 'src/app/shared/common-standalone.module';

@Component({
  selector: 'app-service-interval',
  standalone: true,
  imports: [CommonStandaloneModule, SharedDependenciesModule, MatSelectModule, MatFormFieldModule],
  templateUrl: './service-interval.component.html',
  styleUrl: './service-interval.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceIntervalComponent implements OnInit {
  readonly FeaturePropertyKey = FeaturePropertyKey;
  readonly FeatureCommands = FeatureCommands;
  readonly FeatureActionFields = FeatureActionFields;

  @Input() device: RichDevice;

  serviceTimeBased$: Observable<Feature<ServiceTimeBasedProperties, ServiceTimeBasedCommands>>;
  setServiceIntervalMonths: number;
  intervals: number[];

  constructor(
    private installationFeaturesStore: InstallationFeaturesStore,
    private gtmService: GTMService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.serviceTimeBased$ = this.installationFeaturesStore
      .selectInstallationDeviceFeature<ServiceTimeBasedProperties, ServiceTimeBasedCommands>(
        FeatureNames.serviceTimeBased,
        this.device?.id
      )
      .pipe(
        tap((feature) => {
          this.intervals =
            feature?.commands?.[
              FeatureCommands.setServiceIntervalMonths
            ]?.params?.value?.constraints?.enum;
        })
      );
  }

  onSetServiceIntervalMonthsChange(value: number): void {
    this.installationFeaturesStore.updateFeature(
      FeatureNames.serviceTimeBased,
      value,
      null,
      FeatureActionFields.value,
      FeatureCommands.setServiceIntervalMonths,
      this.device.gatewaySerial,
      this.device.id,
      {
        successMessage: this.translate.instant(
          '+INSTALLATIONS.INSTALLATION.MAINTENANCE_INFORMATION.MONTH_INTERVAL.SUCCESS'
        ),
      }
    );
    this.gtmService.track('onConfirm', 'Change service interval month value ', 'systemDetails');
  }
}
